module.exports = __webpack_public_path__ + "2a453d09820a5d826d16b6942592e56c.svg";